import { useQuery } from "react-query";
import { GET_SOCIAL_HISTORY, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { getSocialHistory } from "api/customers";

const useGetSocialHistory = (clientId: number | null) => {
  const { data, isLoading, refetch, ...rest } = useQuery(
    [GET_SOCIAL_HISTORY, clientId],
    () => getSocialHistory(clientId),
    {
      staleTime: STALE_TIME_5_MINUTES,
      enabled: Boolean(clientId),
      refetchOnWindowFocus: false,
    }
  );

  return {
    socialHistory: (data?.data || []) as any[],
    socialHistoryLoading: isLoading,
    refetchSocialHistory: refetch,
    ...rest,
  };
};

export default useGetSocialHistory;
